import * as types from '../mutation-types'
import { API, message } from '../../api'
import { MOMENT_TIME } from '../../momenttime';
import { CONFIG } from '../../config';
import { UTILS } from '../../utils';

export default {
    namespaced: true,
    state: {
        gotAllExtList: false,
        allExtListData: {},
        showVersionReminder: false,
        showDownloadReminder: true,
        showDetailReminder: false,
        versionExtTime: {},
        versionKeyArr: ['1.5.0'],
        detailExtTime: {},      // 八字详情提示
        detailKeyArr: ['name', 'fate', 'share'],       // 八字详情提示:key数组
        showShareReminder: false,
        shareExtTime: {},       // 分享八字提示
        shareKeyArr: ['save', 'collate'],         // 分享八字提示:key数组
        showCollateReminder: false,
        collateExtTime: {},
        collateKeyArr: ['float', 'label'],
        aitips: 1,                         // 测算入口配置
        aiButtonClickedStatus: true,        // 测算入口按钮状态
        aiCharacter: 0,                     // 天赋性格弹框
        showVipReminder: false,             // VIP红点
        showVipPop: false,                  // 显示弹框
        curVipShowTime: 0,                  // 当前vip显示次数
        vipCountTime: 0,                    // vip弹框倒计时时间
        startVipCount: false,               // 开始vip弹框倒计时
        vipIsToday: false,                  // vip还是不是今天在弹框
    },
    getters: {},
    mutations: {
        [types.REMINDER_UPDATE_STATUS_DATA](state, data) {
            var newData = data == [] ? {} : data;
            console.log('REMINDER_UPDATE_STATUS_DATA:::::::', data, newData);
            state.detailExtTime = newData['detailExtTime'] ? newData['detailExtTime'] : state.detailExtTime;
            state.shareExtTime = newData['shareExtTime'] ? newData['shareExtTime'] : state.shareExtTime;
            state.collateExtTime = newData['collateExtTime'] ? newData['collateExtTime'] : state.collateExtTime;
            state.aitips = newData['aitips'] ? newData['aitips'] : state.aitips;
            state.aiCharacter = newData['aiCharacter'] ? newData['aiCharacter'] : state.aiCharacter;
        }
    },
    actions: {
        getAllExtList({dispatch, commit, state}, params) {
            var userData = AppFate.$store.state.userData;
            if(state.gotAllExtList) { return; }
            API.getAllExtList({}, function(data){
                state.gotAllExtList = true;
                state.allExtListData = data;
                console.log('getAllExtList:::::::', data);
                commit(types.REMINDER_UPDATE_STATUS_DATA, data);
                dispatch('checkReportAIStatus');
                state.showVipReminder = data['h5_vip_red'] && parseInt(data['h5_vip_red']) == 1 ? false : true;
                dispatch('activity/initActSetting', data, {root: true});
                if(parseInt(userData.isnewuser) === 0 && params.vip == 0) {
                    console.log('自动弹框vip')
                    // todo 2021.10.01 暂时去掉vip的弹框提示
                    // dispatch('checkVipPopStatus', Object.assign({
                    //     data: data
                    // }, params))
                }else {
                    if(params.appCb && typeof(params.appCb) == 'function') {
                        params.appCb();
                    }
                }
                // 课程中心vip弹框
                if(params.vip != 0) {
                    if(params.vipCourseCb && typeof(params.vipCourseCb) == 'function') {
                        params.vipCourseCb(data);
                    }
                }
            });
        },
        udpateExtList({commit, state}, params) {
            console.log('udpateExtList-----', params);
            API.updateExtList({
                info: JSON.stringify(params.params)
            }, function(data) {
                console.log('udpateExtList:::::::', data);
                commit(types.REMINDER_UPDATE_STATUS_DATA, data);
                // 执行回调函数
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        checkDetailExtTime({state}) {
            console.log('checkDetailExtTime-------', state.detailExtTime)
            if(state.detailExtTime['name'] == 1 && state.detailExtTime['fate'] == 1 && state.detailExtTime['share'] == 1) {
                state.showDetailReminder = false;
            }else {
                state.showDetailReminder = true;
            }
        },
        checkShareExtTime({state}) {
            console.log('checkShareExtTime-------', state.shareExtTime)
            if(state.shareExtTime['save'] == 1 && state.shareExtTime['collate'] == 1) {
                state.showShareReminder = false;
            }else {
                state.showShareReminder = true;
            }
        },
        checkCollateExtTime({state}) {
            console.log('checkCollateExtTime-------', state.collateExtTime)
            if(state.collateExtTime['float'] == 1 && state.collateExtTime['label'] == 1) {
                state.showCollateReminder = false;
            }else {
                state.showCollateReminder = true;
            }
        },
        checkReportAIStatus({dispatch, state}) {
            console.log('checkReportAIStatus-------', state.aitips)
            // // for test
            state.aiButtonClickedStatus = false;
            // var params = {"aitips": ''};
            // dispatch('udpateExtList', { params: params });
            // return;
            var curTime = MOMENT_TIME.getTimeStampByNow();
            if(!state.aitips) {
                var params = {"aitips": curTime};
                dispatch('udpateExtList', { params: params });
                state.aiButtonClickedStatus = false;
            }else {
                if(state.aitips == 1) {
                    state.aiButtonClickedStatus = true;
                }else {
                    var dValue = curTime - parseInt(state.aitips),
                        compValue = 7 * 24 * 3600; // 7天
                        // compValue = 300; // 5分钟 for test
                    state.aiButtonClickedStatus = dValue > compValue ? true : false;
                    console.log('checkReportAIStatus-------相差时间', dValue)
                }
            }
        },
        checkVipPopStatus({dispatch, state}, params) {
            // for test
            // dispatch('udpateExtList', { params: {"act_vlts_t_t_t_t": '', "h5_vip_red": ''} });
            // return;
            // for test
            var vipStr = params.data['act_vlts_t_t_t_t'],
                vipArr = vipStr && vipStr != '' ? vipStr.split('_') : [];
            console.error('vipArr-----', vipArr);
            var curTimeArr = MOMENT_TIME.getTimeArrayByTimeStamp();
            // 第一次字段为空
            if(vipArr.length == 0) {
                console.log('checkVipPopStatus-----', vipArr, params)        
                state.showVipPop = true;        
                state.vipCountTime = CONFIG.vip_count_time;
                state.startVipCount = true;
                if(params.vipCb && typeof(params.vipCb) == 'function') {
                    params.vipCb();
                }
                dispatch('updateVipPopStatus', {
                    curTime: curTimeArr[0]+UTILS.getTimeStrByInt(curTimeArr[1])+UTILS.getTimeStrByInt(curTimeArr[2]),
                    curShowTime: 1,
                    totalShowTime: CONFIG.vip_show_time,
                });
                return;
            }
            var vipY = parseInt(vipArr[0].slice(0, 4)), 
                vipM = parseInt(vipArr[0].slice(4, 6)), 
                vipD = parseInt(vipArr[0].slice(6, 8));
            var isToday = vipY == curTimeArr[0] && vipM == curTimeArr[1] && vipD == curTimeArr[2] ? true : false,
                haveTime = parseInt(vipArr[1]) < parseInt(vipArr[2]) ? true : false;
            // 字段不为空
            console.error('!-------', isToday, haveTime);
            state.vipIsToday = isToday;

            if(isToday) {
                var lsTime = localStorage.getItem('h5_vip_count_time');
                console.log('today---lsTime', lsTime)
                state.showVipPop = parseInt(lsTime) > 0 ? true : false;
                state.curVipShowTime = vipArr.length > 0 ? parseInt(vipArr[1]) : 0;
                if(params.vipCb && typeof(params.vipCb) == 'function') {
                    params.vipCb();
                }
                return;
            }
            
            if(!isToday && haveTime) {
                state.showVipPop = true;
                state.vipCountTime = parseInt(vipArr[3]);
                state.startVipCount = true;
                if(params.vipCb && typeof(params.vipCb) == 'function') {
                    params.vipCb();
                }
                dispatch('updateVipPopStatus', {
                    curTime: curTimeArr[0]+UTILS.getTimeStrByInt(curTimeArr[1])+UTILS.getTimeStrByInt(curTimeArr[2]),
                    curShowTime: parseInt(vipArr[1])+1,
                    totalShowTime: parseInt(vipArr[2]),
                });
                console.log('checkVipPopStatus------', vipStr, vipArr, vipY, vipM, vipD, curTimeArr)
            }
        },
        updateVipPopStatus({state}, params) {
            var vipStr = params.curTime+'_'+params.curShowTime+'_'+params.totalShowTime+'_'+state.vipCountTime;
            var infoP = JSON.stringify({
                act_vlts_t_t_t_t: vipStr
            });
            console.log('updateVipPopStatus-----', params, vipStr, infoP)
            API.updateExtList({
                info: infoP
            }, function(data) {
                console.log('udpateExtList:::::::', data);
                state.curVipShowTime = params.curShowTime;
            })
        },
        resetData({state}) {
            state.gotAllExtList = false;
        }
    }
}
